import { handleRedirection } from './payment-redirection';
import { init as initPaymentOney } from './payment-oney';
import { i18n } from '@/commons/utils';
import { isSecondaryBlockOpened } from '@/checkout/payment/payment';

export const PaymentWithForm = function PaymentWithForm() {
  this.init = function init(_params) {
    this.container = _params.container;
    this.parent = _params.parent;
    this.onExpressConfirmation = _params.onExpressConfirmation;

    this.state = {
      selected: _params.selected || false,
      errors: {},
      additionnalParameters: {}
    };

    this.props = {
      isExpress: _params.isExpress || false,
      isCheckout: _params.isCheckout || false,
      orderId: _params.orderId,
      multiEnabled: this.container.getAttribute('data-multi-enabled') === 'true',
      paymentTypeId: this.container.getAttribute('data-payment-type-id')
    };

    this.elements = {};
    if (this.props.isExpress === false) {
      this.elements.header = this.container.querySelector('.dkt-block-header');
      this.elements.content = this.container.querySelector('.dkt-block-content');
    } else {
      this.elements.content = this.container;
    }

    this.initiateDatePicker();
    this.events();

    if (this.state.selected === true) {
      this.select();
    }

    const { paymentName } = this.container.dataset;
    if (paymentName === 'ONEY_-_CB3X' || paymentName === 'ONEY_-_CB4X') {
      initPaymentOney(this.container);
    }
  };
};

PaymentWithForm.prototype.events = function events() {
  document.addEventListener('clickedOnPay', this.checkPayment.bind(this));
  document.addEventListener('PrimaryPaymentBlockSelected', this.unselect.bind(this));
  if (this.props.isCheckout === true) {
    this.elements.header.addEventListener('click', this.select.bind(this));
  }
};

PaymentWithForm.prototype.select = function select(event) {
  if ((this.state.selected === false && event) || !event) {
    document.dispatchEvent(new CustomEvent('PrimaryPaymentBlockSelected', {
      bubbles: false,
      cancelable: false,
      detail: {
        'multiEnabled': this.props.multiEnabled
      }
    }));
    $(this.elements.content).slideDown('fast', this.displaySelect.bind(this));
    this.state.selected = true;
    if (this.props.isExpress === false && this.parent.enableButton) {
      this.parent.enableButton();
    }
  }
};

PaymentWithForm.prototype.unselect = function unselect() {
  $(this.elements.content).slideUp('normal', this.displayUnselect.bind(this));
  this.state.selected = false;
};

PaymentWithForm.prototype.displaySelect = function displaySelect() {
  this.container.classList.add('dkt-block--selected');
  this.container.classList.add('dkt-block--open');
};

PaymentWithForm.prototype.displayUnselect = function displayUnselect() {
  this.container.classList.remove('dkt-block--selected');
  this.container.classList.remove('dkt-block--open');
};

PaymentWithForm.prototype.checkPayment = function checkPayment() {
  if (this.state.selected === true) {
    if (this.parent.checkTermsOfUse() === false) {
      return;
    }

    if (this.props.isCheckout) {
      if (this.parent.checkBillingAddress && this.parent.checkBillingAddress() === false) return;
      if (this.parent.isFullSecondaryPayment && this.parent.isFullSecondaryPayment() === true) return;
    }
    this.checkForm();
  }
};

PaymentWithForm.prototype.submitPayment = function submitPayment() {
  const { props, state } = this;

  const redirectionUrl = cube.$id('redirectionUrl') !== null ? cube.$id('redirectionUrl').value : null;
  const paymentUrl = cube.$id('paymentUrl') !== null ? cube.$id('paymentUrl').value : null;
  const pspRedirectionUrl = cube.$id('pspRedirectionUrl') !== null ? cube.$id('pspRedirectionUrl').value : null;

  const params = {
    paymentTypeId: props.paymentTypeId,
    redirectionUrl,
    paymentUrl,
    pspRedirectionUrl,
    orderAttributes: JSON.stringify(this.parent.getAnalyticsInfos()),
    orderId: props.orderId,
    additionnalParameters: JSON.stringify(state.additionnalParameters)
  };

  params.useSecondaryMop = isSecondaryBlockOpened();

  if (this.parent.displayLoader) {
    this.parent.displayLoader();
  }

  cube.ajax
    .post('rest/model/com/decathlon/cube/commerce/payment/PaymentActor/applyPayment', params)
    .onSuccess(response => this.handleResponse(response))
    .onError(() => this.submitPaymentError())
    .call();
};

PaymentWithForm.prototype.handleResponse = function handleResponse(response) {
  // Test if there is an authentication error, show error message and hide loader:
  if (
    response.responseTO !== undefined &&
    response.responseTO.errors.length > 0
  ) {
    const error = response.responseTO.errors[0];
    if (error.code === 'PAY_0012') {
      this.parent.displayError(error.message);
      this.parent.hideLoader();
    }
  } else {
    handleRedirection(this, response);
  }
};

PaymentWithForm.prototype.submitPaymentError = function submitPaymentError() {
  if (this.parent.hideLoader) {
    this.parent.hideLoader();
  }
  if (this.parent.displayError) {
    this.parent.displayError(i18n('TECH_0001'), 0);
  }
};

PaymentWithForm.prototype.initiateDatePicker = () => {
  if (cube.$id('tb-birthdate') === null) return;

  const birthdate = $('#tb-birthdate');
  birthdate.datetimepicker();
  birthdate.data('DateTimePicker').maxDate(new Date());
  birthdate.on('dp.change', e => {
    const date = new Date(e.date);
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (day < 10) {
      day = `0${day}`;
    }
    if (month < 10) {
      month = `0${month}`;
    }

    cube.$id('afterpay-birthdate').value = `${year}-${month}-${day}`;
  });
};

PaymentWithForm.prototype.checkForm = function checkForm() {
  const fields = this.elements.content.querySelectorAll('.dkt-field');
  this.elements.fields = [];
  [...fields].map(field => {
    switch (field.dataset.role) {
      case 'birthdate-field':
        this.checkBirthdate();
        break;
      case 'gender-field':
        this.checkGender();
        break;
      case 'email-field':
        this.checkEmail();
        break;
      case 'phone-field':
        this.checkPhone();
        break;
      case 'consent-field':
        this.checkConsent();
        break;
      default:
        return null;
    }
    this.elements.fields.push(field);
    return null;
  });

  if (this.isValid() === true) {
    this.submitPayment();
  }
};

PaymentWithForm.prototype.isValid = function isValid() {
  const { errors } = this.state;
  return !Object.values(errors).find(error => error === true);
};

PaymentWithForm.prototype.checkBirthdate = function checkBirthdate() {
  const { state, elements } = this;
  const birthdate = elements.content.querySelector('#tb-birthdate');
  const birthdateContainer = elements.content.querySelector('[data-role=birthdate-field]');
  const birthdateHiddenInput = elements.content.querySelector('#afterpay-birthdate');

  elements.birthdateContainer = birthdateContainer;

  if (!birthdate.value || birthdate.value === '') {
    this.displayFieldError(birthdateContainer, i18n('payment.afterpay.errorMessage.birthdate'));
    state.errors.birthdate = true;
  } else {
    this.hideFieldError(birthdateContainer);
    state.errors.birthdate = false;
    state.additionnalParameters.birthdate = birthdateHiddenInput.value;
  }

  $('body').on('dp.change', birthdate, () => {
    this.hideFieldError(birthdateContainer);
    state.errors.birthdate = false;
  });

  birthdate.addEventListener('propertychange change click keyup input paste dp.change', () => {
    this.hideFieldError(birthdateContainer);
    state.errors.birthdate = false;
  });
};

PaymentWithForm.prototype.checkGender = function checkGender() {
  const genderOptions = this.elements.content.querySelectorAll('[name=rb-gender]:checked');
  const genderContainer = this.elements.content.querySelector('[data-role=gender-field]');

  if (genderOptions.length === 0) {
    this.displayFieldError(genderContainer, i18n('payment.afterpay.errorMessage.gender'));
    this.state.errors.gender = true;
  } else {
    this.hideFieldError(genderContainer);
    this.state.errors.gender = false;
    this.state.additionnalParameters.gender = cube.$('[name=rb-gender]').value;
  }
};

PaymentWithForm.prototype.checkEmail = function checkEmail() {
  const email = this.elements.content.querySelector('#tb-email-address');
  const emailContainer = this.elements.content.querySelector('[data-role=email-field]');
  const testEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!email.value || email.value === '' || testEmail.test(email.value) === false) {
    this.displayFieldError(emailContainer, i18n('payment.afterpay.errorMessage.email'));
    this.state.errors.email = true;
  } else {
    this.hideFieldError(emailContainer);
    this.state.errors.email = false;
    this.state.additionnalParameters.email = email.value;
  }
};

PaymentWithForm.prototype.checkPhone = function checkPhone() {
  const phone = this.elements.content.querySelector('#tb-phone');
  const phoneContainer = this.elements.content.querySelector('[data-role=phone-field]');

  if (!phone.value || phone.value === '') {
    this.displayFieldError(phoneContainer, i18n('payment.afterpay.errorMessage.phone'));
    this.state.errors.phone = true;
  } else {
    this.hideFieldError(phoneContainer);
    this.state.errors.phone = false;
    this.state.additionnalParameters.phone = cube.$id('tb-phone').value;
    this.state.additionnalParameters.countrycode = $('[name="countryCode"]').children(':selected').val();
  }
};

PaymentWithForm.prototype.checkConsent = function checkPhone() {
  const consent = this.elements.content.querySelector('#tb-consent');
  const consentContainer = this.elements.content.querySelector('[data-role=consent-field]');

  if (!consent.checked) {
    this.displayFieldError(consentContainer, i18n('payment.payolution.errorMessage.consent'));
    this.state.errors.consent = true;
  } else {
    this.hideFieldError(consentContainer);
    this.state.errors.consent = false;
  }
};

PaymentWithForm.prototype.displayFieldError = (element, text) => {
  element.classList.add('dkt-field--error');
  const errorMessage = element.querySelector('.dkt-error-message');
  if (!errorMessage) {
    const message = document.createElement('span');
    message.className = 'dkt-error-message';
    message.innerText = text;
    element.appendChild(message);
  }
};

PaymentWithForm.prototype.hideFieldError = element => {
  const message = element.querySelector('.dkt-error-message');
  if (message) {
    message.parentNode.removeChild(message);
  }
  element.classList.remove('dkt-field--error');
};



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-with-form.js